import React from 'react'
import styles from './ActionButtons.module.scss'
import { func } from 'prop-types'
const ActionButtons = ({ setToggleFilmTimes, setToggleTrailer }) => {
  return (
    <>
      {setToggleTrailer && (
        <button
          onClick={() => setToggleTrailer(true)}
          className={styles.Button}
        >
          Watch Trailer
        </button>
      )}
      {setToggleFilmTimes && (
        <button
          onClick={() => setToggleFilmTimes(true)}
          className={styles.Button}
        >
          Search Film Times
        </button>
      )}
    </>
  )
}
ActionButtons.propTypes = {
  setToggleFilmTimes: func,
  setToggleTrailer: func
}
export default ActionButtons
